import { ApplicationRootState } from 'redux-core/types';

export const selectKPICardData = (state: ApplicationRootState): boolean =>
    state.app.dashboard.KPICard.data;

export const selectKPICardStatus = (state: ApplicationRootState): string =>
    state.app.dashboard.KPICard.status;
